module.exports = require("@angular/core");